<div class="min-h-screen bg-station-cream px-4 py-12 md:py-16">
  <article
    class="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-6 md:p-10 [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-flap-black [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-flap-black [&_h3]:mt-5 [&_h3]:mb-2 [&_p]:text-rail-gray [&_p]:leading-relaxed [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-3 [&_li]:text-rail-gray [&_li]:leading-relaxed [&_li]:mb-1 [&_strong]:font-semibold [&_strong]:text-flap-black [&_a]:text-signal-orange [&_a]:font-semibold hover:[&_a]:underline"
  >
    <h1 class="text-3xl md:text-4xl font-bold text-flap-black mb-2">Terms of Service</h1>
    <p><strong>Effective Date:</strong> July 24, 2026</p>
    <p><strong>Website:</strong> FlippyBoards.com</p>

    <h2>1. Acceptance of Terms</h2>
    <p>
      By accessing or using FlippyBoards.com ("the Service"), a website operated by FlippyBoards.com
      ("we," "us," or "our"), you agree to be bound by these Terms of Service ("Terms"). If you do
      not agree to these Terms, please do not use the Service.
    </p>

    <h2>2. Description of Service</h2>
    <p>
      FlippyBoards.com provides users with a platform to create virtual split-flap display boards
      with custom messages and share them with others via a unique URL. Boards you create can be
      viewed by anyone who has the board's URL; you may optionally protect a board with a passcode.
    </p>

    <h2>3. Account Registration</h2>
    <p>
      To create boards, you must register an account by providing accurate and complete information.
      You may register with an email address and password, or by signing in with a third-party
      identity provider such as Google. You are responsible for:
    </p>
    <ul>
      <li>Maintaining the confidentiality of your account credentials</li>
      <li>All activities that occur under your account</li>
      <li>Notifying us immediately of any unauthorized use of your account</li>
    </ul>
    <p>You must be at least 13 years of age to use this Service.</p>

    <h2>4. User Content</h2>
    <h3>4.1 Ownership</h3>
    <p>
      You retain all ownership rights to the boards, messages, and other content you create on the
      Service ("Your Content"). By using the Service, you do not transfer any ownership rights to
      us.
    </p>

    <h3>4.2 License to Us</h3>
    <p>
      You grant us a limited license to store, process, and display Your Content for the purpose of
      providing the Service, including displaying Your Content to anyone you share a board link
      with.
    </p>

    <h3>4.3 Public Nature of Boards</h3>
    <p>
      Boards are designed to be shared. Anyone with a board's URL (and passcode, if set) can view
      its content. You are responsible for deciding what you share and with whom. Do not include
      personal, confidential, or sensitive information in board content.
    </p>

    <h3>4.4 Responsibility for Content</h3>
    <p>You are solely responsible for Your Content and warrant that:</p>
    <ul>
      <li>You have the right to create and share such content</li>
      <li>Your Content does not infringe on any third-party rights</li>
      <li>Your Content does not violate any applicable laws</li>
    </ul>

    <h3>4.5 Prohibited Content</h3>
    <p>You agree not to create or share content that:</p>
    <ul>
      <li>Is illegal, harmful, or violates any laws</li>
      <li>Harasses, threatens, defames, or targets any person or group</li>
      <li>Is hateful, obscene, or sexually explicit</li>
      <li>Infringes on intellectual property rights of others</li>
      <li>Impersonates any person or entity, or misrepresents your affiliation</li>
      <li>
        Violates the privacy or rights of others, including sharing another person's personal
        information without consent
      </li>
    </ul>
    <p>
      We reserve the right to remove content and suspend or terminate accounts that violate these
      rules.
    </p>

    <h2>5. Privacy and Data</h2>
    <p>
      Your use of the Service is also governed by our Privacy Policy. We store your account
      information securely. Your account information (name, email address) is not displayed on
      shared boards; board content is visible to anyone with the board link as described in Section
      4.3.
    </p>

    <h2>6. Acceptable Use</h2>
    <p>You agree to use the Service only for lawful purposes. You will not:</p>
    <ul>
      <li>Attempt to gain unauthorized access to our systems or other user accounts</li>
      <li>Attempt to access passcode-protected boards without authorization</li>
      <li>Use the Service to store or distribute malicious code or conduct malicious activities</li>
      <li>Interfere with or disrupt the Service or servers</li>
      <li>Use automated means to access the Service without our permission</li>
      <li>Attempt to reverse engineer or compromise the security of the Service</li>
    </ul>

    <h2>7. Service Availability</h2>
    <p>We strive to provide reliable service but do not guarantee that the Service will be:</p>
    <ul>
      <li>Uninterrupted or error-free</li>
      <li>Free from viruses or harmful components</li>
      <li>Available at all times</li>
    </ul>
    <p>
      We reserve the right to modify, suspend, or discontinue the Service at any time with or
      without notice.
    </p>

    <h2>8. Data Backup</h2>
    <p>
      While we implement reasonable measures to protect your data, you are responsible for
      maintaining your own backups of Your Content. We are not liable for any loss of data.
    </p>

    <h2>9. Termination</h2>
    <h3>9.1 By You</h3>
    <p>
      You may terminate your account at any time by using the account deletion feature in your
      profile settings or by contacting us.
    </p>

    <h3>9.2 By Us</h3>
    <p>
      We reserve the right to suspend or terminate your account if you violate these Terms or for
      any other reason at our discretion. Upon termination, your access to the Service and Your
      Content will cease, and boards associated with your account will no longer be viewable.
    </p>

    <h2>10. Disclaimer of Warranties</h2>
    <p>
      THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER
      EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
    </p>

    <h2>11. Limitation of Liability</h2>
    <p>
      TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL,
      SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER
      INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE
      LOSSES RESULTING FROM:
    </p>
    <ul>
      <li>Your use or inability to use the Service</li>
      <li>
        Any unauthorized access to or use of our servers and/or any personal information stored
        therein
      </li>
      <li>Any interruption or cessation of the Service</li>
      <li>Any loss or damage to Your Content</li>
      <li>Any content shared by other users of the Service</li>
    </ul>

    <h2>12. Indemnification</h2>
    <p>
      You agree to indemnify and hold harmless FlippyBoards.com and its affiliates from any claims,
      damages, losses, liabilities, and expenses (including legal fees) arising from:
    </p>
    <ul>
      <li>Your use of the Service</li>
      <li>Your violation of these Terms</li>
      <li>Your violation of any rights of another party</li>
      <li>Your Content</li>
    </ul>

    <h2>13. Changes to Terms</h2>
    <p>
      We reserve the right to modify these Terms at any time. We will notify users of material
      changes by posting the updated Terms on the Service with a new effective date. Your continued
      use of the Service after such changes constitutes acceptance of the modified Terms.
    </p>

    <h2>14. Governing Law</h2>
    <p>
      These Terms shall be governed by and construed in accordance with the laws of the United
      States and the state in which we operate, without regard to conflict of law provisions.
    </p>

    <h2>15. Entire Agreement</h2>
    <p>
      These Terms constitute the entire agreement between you and FlippyBoards.com regarding the use
      of the Service and supersede any prior agreements.
    </p>

    <h2>16. Contact Information</h2>
    <p>If you have any questions about these Terms, please contact us at:</p>
    <p>
      <a href="mailto:hello@flippyboards.com">hello&#64;flippyboards.com</a>
    </p>

    <hr class="my-8 border-border-subtle" />
    <p><em>Last Updated: September 4, 2026</em></p>
  </article>
</div>
